import { render, staticRenderFns } from "./UsersConfigView.vue?vue&type=template&id=735a893d"
import script from "./UsersConfigView.vue?vue&type=script&lang=js"
export * from "./UsersConfigView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports